import React from "react";
import { Link, Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useI18n } from "@/i18n";
import { Clock, Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AccessGate({ children, adminOnly = false }) {
  const { user, loadingAuth, login } = useApp();
  const { t } = useI18n();

  if (loadingAuth) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-9 h-9 rounded-full border-2 border-[#0E382B] border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="gate-login">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-[#E8F0EC] flex items-center justify-center">
          <Lock className="w-8 h-8 text-[#0E382B]" />
        </div>
        <h1 className="mt-6 font-serif text-3xl font-semibold text-[#0E382B]">{t("gate.loginTitle")}</h1>
        <p className="mt-3 text-[#52635B]">{t("gate.loginBody")}</p>
        <Button onClick={login} className="mt-6 rounded-full bg-[#0E382B] hover:bg-[#1C5442] text-white px-7 h-12" data-testid="gate-login-button">
          {t("gate.loginBtn")}
        </Button>
      </div>
    );
  }

  const approved = user.is_admin || user.access_status === "approved";

  if (adminOnly && !user.is_admin) {
    return <Navigate to="/" replace />;
  }

  if (!approved) {
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="gate-pending">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-[#FEF3C7] flex items-center justify-center">
          <Clock className="w-8 h-8 text-[#B45309]" />
        </div>
        <h1 className="mt-6 font-serif text-3xl font-semibold text-[#0E382B]">{t("gate.pendingTitle")}</h1>
        <p className="mt-3 text-[#52635B]">{t("gate.pendingBody")}</p>
        <p className="mt-4 inline-flex items-center gap-2 text-sm text-[#0E5A35] bg-[#E8F0EC] rounded-full px-4 py-2">
          <Sparkles className="w-4 h-4" /> {t("gate.pendingHint")}
        </p>
        <div className="mt-7">
          <Link to="/">
            <Button variant="outline" className="rounded-full border-[#E2DFD7]">{t("gate.backHome")}</Button>
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
